document.addEventListener('DOMContentLoaded', () => {
  /**
   * Returns true if the .coa-main-header__hamburger
   * is visibly rendered (i.e. in "mobile" layout).
   *
   * Using offsetParent is more robust than checking
   * getComputedStyle(...).display === 'none'.
   */
  const isMobileView = () => {
    const hamburgerButton = document.querySelector('.coa-main-header__hamburger');
    // If no hamburger found, assume desktop
    if (!hamburgerButton) return false;
    // If offsetParent is null => element is display:none (or not in layout)
    return hamburgerButton.offsetParent !== null;
  };

  /**
   * Close all open submenus.
   */
  const closeAllSubmenus = () => {
    const openSubmenus = document.querySelectorAll('.submenu.open');
    openSubmenus.forEach(submenu => {
      submenu.classList.remove('open');
      submenu.style.removeProperty('min-height'); // Clean up any min-height we set
      const menuItem = submenu.closest('.primary-menu__main-item');
      if (menuItem) {
        menuItem.classList.remove('current-menu-item');
        const chevron = menuItem.querySelector('.open-submenu');
        if (chevron) chevron.classList.remove('rotated');
      }
    });
  };

  /**
   * Opens the submenu for a given .primary-menu__main-item.
   * First closes other submenus.
   */
  const openSubmenu = (menuItem) => {
    if (!menuItem) return;
    closeAllSubmenus();

    const submenu = menuItem.querySelector('.submenu');
    const chevron = menuItem.querySelector('.open-submenu');
    if (submenu) {
      submenu.classList.add('open');

      // --- Add this min-height only in desktop view ---
      if (!isMobileView()) {
        const header = document.querySelector('.coa-main-header');
        if (header) {
          const viewportHeight = window.innerHeight;
          const headerHeight = header.offsetHeight;
          const availableHeight = viewportHeight - headerHeight;
          submenu.style.minHeight = availableHeight + 'px';
        }
      }
    }
    if (chevron) chevron.classList.add('rotated');
    menuItem.classList.add('current-menu-item');
  };

  /**
   * Closes the submenu for a given .primary-menu__main-item.
   */
  const closeSubmenu = (menuItem) => {
    if (!menuItem) return;

    const submenu = menuItem.querySelector('.submenu');
    const chevron = menuItem.querySelector('.open-submenu');
    if (submenu) {
      submenu.classList.remove('open');
      submenu.style.removeProperty('min-height'); // Clean up the min-height
    }
    if (chevron) chevron.classList.remove('rotated');
    menuItem.classList.remove('current-menu-item');
  };

  /**
   * Toggles the submenu on mobile click only.
   */
  const toggleSubmenu = (event, link) => {
    // Only toggle if we are in mobile mode
    if (!isMobileView()) return;

    // Prevent navigation in mobile so we can open/close instead
    event.preventDefault();

    const menuItem = link.closest('.primary-menu__main-item');
    if (!menuItem) return;

    const submenu = menuItem.querySelector('.submenu');
    if (!submenu) return;

    const isOpen = submenu.classList.contains('open');
    if (isOpen) {
      closeSubmenu(menuItem);
    } else {
      openSubmenu(menuItem);
    }
  };

  // ========== EVENT BINDINGS ==========

  // 1) Main menu items
  const mainItems = document.querySelectorAll('.primary-menu__main-item');
  mainItems.forEach(menuItem => {
    const link = menuItem.querySelector('.primary-menu__main-link');
    if (!link) return;

    // --- MOBILE MODE (CLICK) ---
    link.addEventListener('click', (event) => {
      toggleSubmenu(event, link);
    });

    // --- DESKTOP MODE (HOVER) ---
    // Mouse enters => open submenu (only if not mobile)
    menuItem.addEventListener('mouseenter', () => {
      if (!isMobileView()) {
        openSubmenu(menuItem);
      }
    });
    // Mouse leaves => close submenu (only if not mobile)
    menuItem.addEventListener('mouseleave', () => {
      if (!isMobileView()) {
        closeSubmenu(menuItem);
      }
    });
  });

  // 2) Close buttons inside submenus
  const closeButtons = document.querySelectorAll('.close-submenu');
  closeButtons.forEach(button => {
    button.addEventListener('click', () => {
      const submenu = button.closest('.submenu');
      if (!submenu) return;
      const menuItem = submenu.closest('.primary-menu__main-item');
      closeSubmenu(menuItem);
    });
  });

  // 3) Close submenus on Escape or outside click
  const handleCloseSubmenus = () => {
    closeAllSubmenus();
  };

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      handleCloseSubmenus();
    }
  });

  document.addEventListener('click', (event) => {
    const isClickInsideMenu = event.target.closest('.primary-menu');
    if (!isClickInsideMenu) {
      handleCloseSubmenus();
    }
  });

  // 4) Mobile Menu Toggle (Hamburger)
  const hamburgerButton = document.querySelector('.coa-main-header__hamburger');
  const primaryMenu = document.querySelector('.primary-menu');

  if (hamburgerButton && primaryMenu) {
    hamburgerButton.addEventListener('click', () => {
      hamburgerButton.classList.toggle('menu-open');
      primaryMenu.classList.toggle('mobile-menu-open');
      // Update aria-expanded
      const isExpanded = hamburgerButton.classList.contains('menu-open');
      hamburgerButton.setAttribute('aria-expanded', isExpanded);
    });
  }

  // 5) Close submenus on window resize if we switch between mobile & desktop
  let previousIsMobile = isMobileView();
  window.addEventListener('resize', () => {
    const currentIsMobile = isMobileView();
    // If we changed mode (mobile <-> desktop), close submenus
    if (currentIsMobile !== previousIsMobile) {
      closeAllSubmenus();
      previousIsMobile = currentIsMobile;
    }
  });
});
